import React from "react";

// UMG text wordmark — Chivo Black, monolithic, tight tracking.
export default function Logo({ className = "", variant = "dark" }) {
  const color = variant === "light" ? "text-white" : "text-ink-900";
  return (
    <span
      className={`font-display font-black uppercase leading-none tracking-tighter select-none ${color} ${className}`}
      aria-label="UMG"
      data-testid="umg-logo"
    >
      UMG
    </span>
  );
}
